import { useState } from 'react';
import * as Yup from 'yup';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Stack, Alert, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// auth
import { useAuthContext } from '../../auth/useAuthContext';
// components
import Iconify from '../../components/iconify';
import FormProvider, { RHFTextField } from '../../components/hook-form';
// ----------------------------------------------------------------------

type FormValuesProps = {
  account: string;
  password: string;
  code:string;
  afterSubmit?: string;
};

export default function AuthLoginForm() {
  const { login } = useAuthContext();
  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    account: Yup.string().required('请输入账号'),
    password: Yup.string().required('请输入密码'),
    // code: Yup.string().required('请输入验证码'),
  });

  const defaultValues = {
    account: '',
    password: '',
    // code:'',
  };

  const methods = useForm<FormValuesProps>({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = methods;

  const onSubmit = async (data: FormValuesProps) => {
    try {
      await login(data.account, data.password);
    } catch (error) {
      console.log('登录错误:', error);
      console.log('错误详情:', error.data);

      reset();
      // getCode()
      setError('afterSubmit', {
        ...error,
        message: error.message || "登录失败，请检查账号密码",
      });
    }
  };
  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}

        <RHFTextField name="account" label="账号" />

        <RHFTextField
          name="password"
          label="密码"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      {/* <Stack direction='row'>
          <RHFTextField name="code" label="验证码" />
          <img style={{width:'100px',marginLeft:'10px',height:'55px',cursor:'pointer'}} onClick={()=>{getCode()}} src={captcha.captcha_code} alt="" />
        </Stack> */}
      </Stack>

      <Stack alignItems="flex-end" sx={{ my: 2 }}>
        {/* <Link variant="body2" color="inherit" underline="always">
          忘记密码?
        </Link> */}
      </Stack>

      <LoadingButton
        fullWidth
        color="inherit"
        size="large"
        type="submit"
        variant="contained"
        loading={isSubmitSuccessful || isSubmitting}
        sx={{
          bgcolor: 'text.primary',
          color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
          '&:hover': {
            bgcolor: 'text.primary',
            color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
          },
        }}
      >
        登录
      </LoadingButton>
    </FormProvider>
  );
}
